module.exports = __webpack_public_path__ + "img/组45.459c947f.png";